// Patients API service using generated OpenAPI client - HATEOAS style
import { apiCall } from './apiService'


// Simple patient type
export interface Patient {
  id: string
  href: string
  first_name: string
  last_name: string
  phone: string
  email: string
  date_of_birth: string
  gender: string
  address: any
}

export interface PatientsListResponse {
  patients: Patient[]
  total: number
  page_size?: number
  page_number?: number
  page_previous?: string | null
  page_next?: string | null
}

export interface PatientsQueryParams {
  name?: string[]
  page_size?: number
  page_number?: number
  sort?: string[]
}

export const patientsApi = {
  // HATEOAS-style: Use the href from clinic.patients.href instead of constructing URL
  // Can handle both base hrefs with params, or full HATEOAS URLs (page_next/page_previous)
  async getPatients(patientsHref: string, params?: PatientsQueryParams): Promise<PatientsListResponse> {
    let finalUrl = patientsHref
    
    // If this is already a complete HATEOAS URL (contains query params), use it directly
    if (patientsHref.includes('?')) {
      console.log('HATEOAS: Using complete pagination URL:', patientsHref)
      finalUrl = patientsHref
    } else {
      // Build query params if provided and this is a base href
      let queryString = ''
      if (params) {
        const searchParams = new URLSearchParams()
        if (params.name) params.name.forEach(n => searchParams.append('name', n))
        if (params.page_size) searchParams.set('page_size', params.page_size.toString())
        if (params.page_number) searchParams.set('page_number', params.page_number.toString())
        if (params.sort) params.sort.forEach(s => searchParams.append('sort', s))
        queryString = searchParams.toString() ? `?${searchParams.toString()}` : ''
      }
      finalUrl = `${patientsHref}${queryString}`
    }
    
    const data = await apiCall(finalUrl)
    console.log('API returned data:', data)
    
    const result = {
      patients: (data?.items || []).map((item: any) => ({
        ...item,
        id: item.id!,
        href: item.href!,
      })),
      total: data?.total_items || 0,
      page_size: data?.page_size,
      page_number: data?.page_number,
      page_previous: data?.page_previous,
      page_next: data?.page_next,
    }
    
    console.log('Service returning:', result)
    console.log('Number of patients:', result.patients.length)
    
    return result
  },

  // HATEOAS-style: POST to the patients href (which includes the clinic context)
  async createPatient(patientsHref: string, patientData: any): Promise<{ id: string; href: string }> {
    return await apiCall(patientsHref, {
      method: 'POST',
      body: JSON.stringify(patientData),
    })
  },

  // HATEOAS-style: Use the patient's own href to get details
  async getPatient(patientHref: string): Promise<Patient> {
    const data = await apiCall(patientHref)
    
    // Handle both single patient and array responses
    const patient = Array.isArray(data?.items) ? data.items[0] : data
    return {
      ...patient,
      id: patient?.id!,
      href: patient?.href!,
    } as Patient
  },

  // HATEOAS-style: PATCH to the patient's own href
  async updatePatient(patientHref: string, patientData: Partial<any>): Promise<{ id: string; status: string; message: string }> {
    return await apiCall(patientHref, {
      method: 'PATCH',
      body: JSON.stringify(patientData),
    })
  },

  // HATEOAS-style: DELETE to the patient's own href
  async deletePatient(patientHref: string): Promise<void> {
    await apiCall(patientHref, {
      method: 'DELETE',
    })
  },

  // HATEOAS-style: GET patient allergies using patient.allergies.href
  async getPatientAllergies(allergiesHref: string): Promise<any[]> {
    const data = await apiCall(allergiesHref)
    return data?.items || []
  },

  // HATEOAS-style: POST to patient.allergies.href  
  async addPatientAllergies(allergiesHref: string, allergyIds: string[]): Promise<void> {
    await apiCall(allergiesHref, {
      method: 'POST',
      body: JSON.stringify(allergyIds),
    })
    // API returns 202 with success message - this is expected and successful
  },

  // HATEOAS-style: DELETE to patient.allergies.href/{ids}
  async removePatientAllergies(allergiesHref: string, allergyIds: string[]): Promise<void> {
    const allergyIdsParam = allergyIds.join(',')
    await apiCall(`${allergiesHref}/${allergyIdsParam}`, {
      method: 'DELETE',
    })
  },
}